import { render, staticRenderFns } from "./MobileAccount.vue?vue&type=template&id=2203b2f6&scoped=true&"
import script from "./MobileAccount.vue?vue&type=script&lang=js&"
export * from "./MobileAccount.vue?vue&type=script&lang=js&"
import style0 from "./MobileAccount.vue?vue&type=style&index=0&id=2203b2f6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2203b2f6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Project\\bogo\\we-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2203b2f6')) {
      api.createRecord('2203b2f6', component.options)
    } else {
      api.reload('2203b2f6', component.options)
    }
    module.hot.accept("./MobileAccount.vue?vue&type=template&id=2203b2f6&scoped=true&", function () {
      api.rerender('2203b2f6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Avatar/MobileAccount.vue"
export default component.exports